// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

const updateSearchQuery = (state, action) => action.query;

export default (state = '', action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_SEARCH_QUERY_STRING]: updateSearchQuery
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/shared/reducers/search-query-string.js